module.exports = __webpack_public_path__ + "img/logo.f4750df5.png";